import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  CircularProgress,
  Hidden,
  Select,
  TextField,
} from "@material-ui/core";

import TableBody from "@material-ui/core/TableBody";

import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import clsx from "clsx";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import {
  addUserGroup,
  copyUserGroup,
  deleteUserGroup,
  getUserGroups,
} from "../../../service/endpoint-manager";
import IconButton from "@material-ui/core/IconButton";
import Loading from "../Shared/Loading";
import Roles from "./Roles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import ShieldIcon from "@mui/icons-material/Shield";
import Tooltip from "@material-ui/core/Tooltip";
import GroupsIcon from "@mui/icons-material/Groups";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useSnackbar } from "notistack";
import { Link, useNavigate } from "react-router-dom";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import MenuItem from "@mui/material/MenuItem";
import { MatxTable, MatxTableCell, MatxTableHead } from "../Shared";

import styles from "../../../styles.module.css";

import { UserGroupTable } from "@thequantumhub/iam-package";

const headCells = [
  {
    label: "Group Name",
    align: "left",
    id: "groupName",
  },
  {
    label: "Creation Time",
    align: "center",
    id: "createdAt",
  },
  {
    label: "Action",
    align: "center",
    id: "groupAction",
  },
];

const UserGroup = () => {
  const useStyles = makeStyles((theme) => ({
    containerStyles: {
      "&.MuiContainer-root": {
        [theme.breakpoints.down("md")]: {
          paddingLeft: "5px",
          paddingRight: "5px",
        },
      },
    },
    userAccessStyles: {
      fontFamily: "poppins, sans-serif",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },

    componentHeadingStyles: {
      textTransform: "uppercase",
      paddingLeft: "1rem",
    },

    search: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      margin: "0 1rem",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
      },
    },

    searchLeft: {
      width: "60%",
      display: "flex",
      alignItems: "center",
      [theme.breakpoints.down("md")]: {
        width: "100%",
        marginBottom: "0.5rem",
      },
    },

    searchRight: {
      width: "40%",
      display: "flex",
      justifyContent: "flex-end",
      [theme.breakpoints.down("md")]: {
        width: "100%",
        justifyContent: "space-between",
        marginTop: "0.5rem",
      },
    },

    searchBoxStyles: {
      width: "50%",
      borderTopRightRadius: "0",
      borderBottomRightRadius: "0",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },

    btnStyles: {
      background: "#1B2132",
      color: "#fff",
    },

    tableBtn: {
      background: "#1b2132",
    },

    searchBtnStyles: {
      padding: "0.5rem",
    },

    tableContainer: {
      margin: "1rem 0",
    },

    tableCellStyles: {
      [theme.breakpoints.down("md")]: {
        fontSize: "0.7rem",
      },
    },

    tableHeaderStyles: {
      fontWeight: "bold",
    },

    cta: {
      display: "flex",
      justifyContent: "flex-end",
    },

    saveBtnStyles: {
      width: "10rem",
    },

    userGroups: {
      cursor: "pointer",
      "&:hover": {
        textDecoration: "underline",
      },
    },

    deleteIconStyles: {
      "&:hover": {
        color: "red",
      },
    },

    dialogCancelBtn: {
      background: "#8a8a8a",
    },

    dialogStyles: {
      "& .MuiPaper-root": {
        width: "100%",
        maxWidth: "400px",
        borderRadius: "20px",
        paddingBottom: "1.25rem",
      },
    },
    adduserGroupDialogStyles: {
      "& .MuiPaper-root": {
        maxWidth: "500px",
      },
    },

    dialogActionStyles: {
      display: "flex",
      justifyContent: "space-between",
      margin: "auto 1rem",
    },

    dialogDeleteBtnStyles: {
      "&:hover": {
        background: "#ff0000",
      },
    },

    accordionSection: {
      margin: "2rem 0",
    },

    mobileHeading: {
      display: "flex",
      alignItems: "center",
      paddingLeft: "1rem",
    },

    accordionDetails: {
      display: "flex",
      alignItems: "center",
      "& > section": {
        flex: "2 1 33%",
        textAlign: "center",
      },
    },

    radioBtnLabel: {
      fontSize: "0.8rem",
    },

    dropdown: {
      borderTopRightRadius: "0",
      borderBottomRightRadius: "0",
      marginRight: "5%",
      backgroundColor: "#f7f7f7",
      height: "2.5rem",
      width: "100%",
      lineHeight: "2rem",
    },

    menuItems: { display: "block" },

    existingUserGroupSelection: {
      display: "flex",
      flexDirection: "column",
      margin: "1rem 0",
    },
  }));

  const classes = useStyles();

  const [userGroups, setUserGroups] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userRoles, setUserRoles] = useState(false);
  const [userGroupId, setUserGroupId] = useState(null);
  const [selectedUserGroup, setSelectedUserGroup] = useState(null);
  const [openAddUserGroupDialog, setOpenAddUserGroupDialog] =
    React.useState(false);
  const [openDeleteUserGroupDialog, setOpenDeleteUserGroupDialog] =
    React.useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [openBulkUpdateRedirectDialog, setOpenBulkUpdateRedirectDialog] =
    useState(false);
  const [newUserGroupPreference, setNewUserGroupPreference] =
    useState("newUserGroup");
  const [existingUserGroup, setExistingUserGroup] = useState(null);
  const [newUserGroupName, setNewUserGroupName] = useState(null);
  const [processingUserGroup, setProcessingUserGroup] = useState(null);

  const navigate = useNavigate();

  // store users associated with a particular userGroup - returned by the delete API when the usergroup has a list of users attached to it
  const [associatedUsers, setAssociatedUsers] = useState(null);

  useEffect(() => {
    setExistingUserGroup("none");
  }, []);

  // this useEffect gets user group info when component initially renders
  useEffect(() => {
    const getUserGroupsInfo = async () => {
      setLoading(true);
      const result = await getUserGroups();
      if (result?.status === 200) {
        setUserGroups(result?.data?.body?.Items);
      }
      setLoading(false);
    };

    getUserGroupsInfo();
  }, []);

  const handleClick = (id, selectedUserGroup) => {
    setUserGroupId(id);
    setSelectedUserGroup(selectedUserGroup);
    setUserRoles(true);
  };

  // method to handle closing addUserGroup dialog
  const handleCloseAddUserGroupDialog = () => {
    setOpenAddUserGroupDialog(false);
  };

  const handleNewUserGroupPreference = (e) => {
    setNewUserGroupPreference(e.target.value);
  };

  // method to handle closing addUserGroup dialog
  const handleCloseDeleteUserGroupDialog = () => {
    setOpenDeleteUserGroupDialog(false);
    setUserGroupId(null);
  };

  const handleCloseBulkUpdateRedirectDialog = () => {
    setOpenBulkUpdateRedirectDialog(false);
  };

  const createUserGroup = async (type, isAdmin) => {
    setProcessingUserGroup(true);
    const result = await addUserGroup(newUserGroupName, type, isAdmin);

    if (result?.status === 200) {
      enqueueSnackbar(`${result?.data?.message}`, {
        variant: "success",
      });

      setUserGroups([...userGroups, result?.data?.body]);
      setOpenAddUserGroupDialog(false);
    } else {
      enqueueSnackbar(`${result?.response?.data?.message}`, {
        variant: "error",
      });
    }
    setProcessingUserGroup(false);
  };

  const copyExistingUserGroup = async () => {
    setProcessingUserGroup(true);
    const result = await copyUserGroup(existingUserGroup, newUserGroupName);

    if (result?.status === 200) {
      enqueueSnackbar(`${result?.data?.message}`, {
        variant: "success",
      });

      setUserGroups([...userGroups, result?.data?.body]);
      setOpenAddUserGroupDialog(false);
    } else {
      enqueueSnackbar(`${result?.response?.data?.message}`, {
        variant: "error",
      });
    }
    setProcessingUserGroup(false);
  };

  const handleUserGroupSelectionForCopy = (e) => {
    setExistingUserGroup(e.target.value);
  };

  //function to delete userGroup when delete icon clicked
  const handleDeleteUserGroup = async (userGroupId) => {
    const result = await deleteUserGroup(userGroupId);

    if (result?.status === 200) {
      // if deleted successfully, also delete from frontend state
      setUserGroups(
        userGroups.filter((userGroup) => userGroup.ID !== userGroupId)
      );
      enqueueSnackbar(`${result?.data?.message}`, {
        variant: "success",
      });
    }

    if (result?.response?.data?.code === 400) {
      enqueueSnackbar(`${result?.response?.data?.message}`, {
        variant: "error",
      });
      if (result?.response?.data?.body?.length > 0) {
        setOpenDeleteUserGroupDialog(false);

        setAssociatedUsers(
          result?.response?.data?.body?.map((userDetail) => {
            return userDetail?.user_id;
          })
        );

        setOpenBulkUpdateRedirectDialog(true);
      }
    }
    setOpenDeleteUserGroupDialog(false);
  };

  if (loading) {
    return <Loading />;
  }

  const handleAddUserGroup = () => {
    if (newUserGroupPreference === "newUserGroup") {
      createUserGroup("scratch", false);
    }

    if (newUserGroupPreference === "adminAccess") {
      createUserGroup("admin", true);
    }

    if (newUserGroupPreference === "copyUserGroup") {
      copyExistingUserGroup();
    }
  };

  return (
    <Container width="sm" className={classes.containerStyles}>
      <section className={classes.userAccessStyles}>
        <h1 className={classes.componentHeadingStyles}>
          {userRoles && (
            <IconButton
              onClick={() => {
                setUserRoles(false);
              }}
            >
              <ArrowBackIcon color="#00000" size="lg" />
            </IconButton>
          )}
          Roles And Permissions
        </h1>
        {!userRoles && (
          <>
            {" "}
            <section className={classes.search}>
              <div className={classes.searchLeft}></div>
              <div className={classes.searchRight}>
                <Button
                  variant="contained"
                  className={styles.primaryButton}
                  onClick={() => {
                    // open Add UserGroup dialog
                    setOpenAddUserGroupDialog(true);
                  }}
                >
                  + User Group
                </Button>
              </div>
            </section>
            {/* table */}
            {userGroups && (
              <UserGroupTable
                styles={styles}
                userGroups={userGroups}
                handleClick={handleClick}
                setUserGroupId={setUserGroupId}
                setOpenDeleteUserGroupDialog={setOpenDeleteUserGroupDialog}
              />
            )}
            {/* Add User Group Dialog - opens when 'Add User Group' button is clicked */}
            <Dialog
              open={openAddUserGroupDialog}
              onClose={handleCloseAddUserGroupDialog}
              maxWidth="lg"
              className={clsx(
                classes.dialogStyles,
                classes.adduserGroupDialogStyles
              )}
            >
              {
                <>
                  <DialogTitle id="add-userGroup-dialog">
                    Add a UserGroup
                  </DialogTitle>
                  <DialogContent>
                    <FormControl component="fieldset">
                      <FormLabel component="legend">Choose an option</FormLabel>
                      <RadioGroup
                        row
                        name="newUserGroupPreference"
                        value={newUserGroupPreference}
                        onChange={handleNewUserGroupPreference}
                      >
                        <Tooltip
                          arrow
                          title="Create a userGroup from scratch with no privileges"
                          placement="top-start"
                        >
                          <FormControlLabel
                            classes={{
                              label: classes.radioBtnLabel,
                            }}
                            value="newUserGroup"
                            control={
                              <Radio
                                size="small"
                                checked={
                                  newUserGroupPreference === "newUserGroup"
                                }
                              />
                            }
                            label="Start from Scratch"
                          />
                        </Tooltip>

                        <Tooltip
                          arrow
                          title="Create a userGroup with Admin privileges"
                          placement="top-start"
                        >
                          <FormControlLabel
                            classes={{
                              label: classes.radioBtnLabel,
                            }}
                            value="adminAccess"
                            control={
                              <Radio
                                size="small"
                                checked={
                                  newUserGroupPreference === "adminAccess"
                                }
                              />
                            }
                            label="Admin Access"
                          />
                        </Tooltip>
                        <Tooltip
                          arrow
                          title="Copy an existing userGroup"
                          placement="top-start"
                        >
                          <FormControlLabel
                            classes={{
                              label: classes.radioBtnLabel,
                            }}
                            value="copyUserGroup"
                            control={
                              <Radio
                                size="small"
                                checked={
                                  newUserGroupPreference === "copyUserGroup"
                                }
                              />
                            }
                            label="Copy UserGroup"
                          />
                        </Tooltip>
                      </RadioGroup>
                    </FormControl>

                    {newUserGroupPreference === "copyUserGroup" && (
                      <section className={classes.existingUserGroupSelection}>
                        <Select
                          variant="outlined"
                          defaultValue={"none"}
                          displayEmpty
                          onChange={(e) => {
                            handleUserGroupSelectionForCopy(e);
                          }}
                          className={classes.dropdown}
                          inputProps={{
                            name: "userGroup",
                            id: "existing-userGroup-Selector",
                          }}
                        >
                          <MenuItem value="none" disabled>
                            Select a UserGroup
                          </MenuItem>
                          {userGroups?.map(
                            (userGroup, index) =>
                              userGroup?.template === false && (
                                <MenuItem
                                  key={userGroup?.ID}
                                  selected={userGroup?.ID}
                                  value={userGroup?.ID}
                                  className={classes.menuItems}
                                >
                                  {userGroup?.name}
                                </MenuItem>
                              )
                          )}
                        </Select>
                      </section>
                    )}

                    <TextField
                      variant="outlined"
                      label="userGroup name"
                      autoFocus
                      margin="dense"
                      placeholder="Add a unique name for the new userGroup"
                      id="name"
                      fullWidth
                      value={newUserGroupName}
                      onChange={(e) => {
                        setNewUserGroupName(e.target.value);
                      }}
                    />
                  </DialogContent>
                  <DialogActions className={classes.dialogActionStyles}>
                    <Button
                      onClick={handleCloseAddUserGroupDialog}
                      className={styles.secondaryButton}
                      variant="contained"
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={handleAddUserGroup}
                      className={styles.primaryButton}
                      variant="contained"
                      disabled={
                        (newUserGroupPreference === "copyUserGroup" &&
                          (existingUserGroup === "none" ||
                            existingUserGroup === "null")) ||
                        newUserGroupName === null ||
                        processingUserGroup
                      }
                    >
                      {processingUserGroup ? (
                        <CircularProgress size={20} />
                      ) : (
                        "Save"
                      )}
                    </Button>
                  </DialogActions>
                </>
              }
            </Dialog>
            {/* Delete User Group Dialog - opens when 'Delete' button is clicked next to each usergroup entry in the table*/}
            <Dialog
              open={openDeleteUserGroupDialog}
              onClose={handleCloseDeleteUserGroupDialog}
              maxWidth="lg"
              className={classes.dialogStyles}
            >
              <DialogTitle id="add-userGroup-dialog">
                Delete UserGroup
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Are you sure you want to delete this userGroup?
                </DialogContentText>
              </DialogContent>
              <DialogActions className={classes.dialogActionStyles}>
                <Button
                  onClick={handleCloseDeleteUserGroupDialog}
                  color="primary"
                  className={clsx(classes.btnStyles, classes.dialogCancelBtn)}
                  variant="contained"
                >
                  Cancel
                </Button>

                <Button
                  onClick={() => {
                    handleDeleteUserGroup(userGroupId);
                  }}
                  color="primary"
                  className={clsx(
                    classes.btnStyles,
                    classes.dialogDeleteBtnStyles
                  )}
                  variant="contained"
                >
                  Delete
                </Button>
              </DialogActions>
            </Dialog>
            {/* Bulk update redirect - opens when 'Delete userGroup' response returns a list of associated users*/}
            <Dialog
              open={openBulkUpdateRedirectDialog}
              onClose={handleCloseBulkUpdateRedirectDialog}
              maxWidth="lg"
              className={classes.dialogStyles}
            >
              <DialogTitle id="bulk-update-dialog">
                Delete UserGroup
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  The users associated to this userGroup need to be updated
                  before the userGroup can be deleted. Do you want to bulk
                  update users?
                </DialogContentText>
              </DialogContent>
              <DialogActions className={classes.dialogActionStyles}>
                <Button
                  onClick={handleCloseBulkUpdateRedirectDialog}
                  color="primary"
                  className={clsx(classes.btnStyles, classes.dialogCancelBtn)}
                  variant="contained"
                >
                  Cancel
                </Button>

                <Button
                  onClick={() => {
                    setOpenBulkUpdateRedirectDialog(false);
                    navigate("/users", {
                      state: {
                        redirectedForBulkUpdate: true,
                        bulkUpdateUserList: associatedUsers,
                      },
                    });
                  }}
                  color="primary"
                  className={clsx(classes.btnStyles)}
                  variant="contained"
                >
                  Bulk Update
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )}
        {userRoles && (
          <section>
            <Roles
              userGroupId={userGroupId}
              setUserGroupId={setUserGroupId}
              userGroups={userGroups}
              selectedUserGroup={selectedUserGroup}
              setSelectedUserGroup={setSelectedUserGroup}
            />
          </section>
        )}
      </section>
    </Container>
  );
};

export default UserGroup;
